import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isCrossdockHubConnectionActive: null,
    isLocationHubConnectionActive: null,
};
const slice = createSlice({
    name: 'shared',
    initialState,
    reducers: {
        setIsCrossdockHubSignalrConnectionActive: (state, action) => {
            state.isCrossdockHubConnectionActive = action.payload;
        },
        setIsLocationHubSignalrConnectionActive: (state, action) => {
            state.isLocationHubConnectionActive = action.payload;
        },
        resetConnectionState: (state) => {
            // resetConnectionState should be called if used is changed
            state.isLocationHubConnectionActive = null;
        },
    },
});
export const { actions: sharedActions, reducer: sharedStateReducer } = slice;
